import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useChannel } from "../../../libs/channels/hooks/use-channel";
import { PageSetChannelsAction } from "../../../redux/page/actions/default";

export const ChannelHandler: React.FC = () => {
    const { partnerType, channel } = useChannel();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(new PageSetChannelsAction({ channel, partnerType }).create());
    }, [partnerType, channel]);
    return null;
};
